import commonMessage from "../../constants/commonMessage";

const { FAQ_QUESTION_REQUIRED, FAQ_ANSWER_REQUIRED } = commonMessage;

export const faq = {
  // Add Faq Schema
  addFaqSchema: {
    question: {
      required: true,
      message: FAQ_QUESTION_REQUIRED,
      extraMessage: false,
    },
    answer: {
      required: true,
      message: FAQ_ANSWER_REQUIRED,
      extraMessage: false,
    },
  },
};
